// import { inject, getCurrentInstance } from 'vue';
import { SignalRSymbol } from './symbols';
import Vue from 'vue';
export function useSignalR() {
  const signalr = Vue[SignalRSymbol];

  if (!signalr) {
    throw new Error('Failed to inject SignalR');
  }

  return signalr;
}
